<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>推广管理</a-breadcrumb-item>
    <a-breadcrumb-item>虚拟回传数据</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 头部功能条 -->
  <div class="head-tool-view">
    <div style="position: relative;">
      <!-- UID -->
      <span class="tool-title">UID：</span>
      <a-input v-model:value="cuid" style="width: 160px;" placeholder="请输入" />
      <!-- 金额 -->
      <span class="tool-title">金额：</span>
      <a-input v-model:value="camount" style="width: 160px;" placeholder="请输入" suffix="元" />
      <!-- 操作 -->
      <a-button type="primary" style="margin-left: 16px;" @click="touchAdd">创建回传</a-button>
      <!-- 加载组件 -->
      <Loading :loading="cisLoading"></Loading>
    </div>
    <!-- 分割线 -->
    <div class="head-tool-space"></div>
  </div>
  <!-- 功能条 -->
  <div class="tool-view">
    <!-- 日期： -->
    <span class="tool-title">日期：</span>
    <a-range-picker
      v-model:value="dateRange"
      :format="dateFormat"
    />
    <!-- UID： -->
    <span class="tool-title">UID：</span>
    <a-input v-model:value="uid" style="width: 160px;" placeholder="请输入" />
    <!-- 推广ID： -->
    <span class="tool-title">推广ID：</span>
    <a-input v-model:value="promotionID" style="width: 160px;" placeholder="请输入" />
    <!-- 操作 -->
    <a-button type="primary" style="margin-left: 16px;" @click="handleSearch">查询</a-button>
    <a-button style="margin-left: 16px;" @click="handleReset">重置</a-button>
    <div style="flex: 1;"></div>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
       <!-- 推广渠道 -->
       <template v-if="column.key === 'channel'">
        {{ (ChannelTypes.find(item => item.value === record[column.key]) || {}).text || '-' }}
      </template>
      <!-- 金额 -->
      <template v-if="column.key === 'amount'">
        {{ $pub.KEEP_NUMBER_DECIMAL((record[column.key] || 0) / 100, 2, false, true) }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { onBeforeMount, ref, reactive, createVNode } from 'vue'
import { message, Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { ChannelTypes } from '@/utils/constant'
import { callbackVirtualList, callbackVirtualDetail, virtualCallback } from '@/api/operate'
import Loading from '@/components/Loading'

// 加载
let isLoading = ref(false)
// 日期范围
let dateRange = ref([dayjs().subtract(30, 'day'), dayjs()])
// 日期format
const dateFormat = 'YYYY-MM-DD'
// 头部 - 加载
let cisLoading = ref(false)
// 头部 - UID
let cuid = ref(undefined)
// 头部 - 金额
let camount = ref(undefined)
// UID
let uid = ref(undefined)
// 推广ID
let promotionID = ref(undefined)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '回传时间',
    dataIndex: 'callback_time',
    key: 'callback_time'
  },
  {
    title: 'UID',
    dataIndex: 'user_id',
    key: 'user_id'
  },
  {
    title: '推广ID',
    dataIndex: 'adv_id',
    key: 'adv_id'
  },
  {
    title: '金额(元)',
    dataIndex: 'amount',
    key: 'amount'
  },
  {
    title: '推广渠道',
    dataIndex: 'channel',
    key: 'channel'
  },
  {
    title: '计划ID',
    dataIndex: 'adid',
    key: 'adid'
  },
  {
    title: '创建人',
    dataIndex: 'create_username',
    key: 'create_username'
  }
])
// 钩子函数
onBeforeMount (() => {
  // 获取注册用户列表
  getList()
})

// 新建回传
function touchAdd () {
  if (!cuid.value) {
    message.error('UID不能为空')
    return
  }
  if (!camount.value) {
    message.error('金额不能为空')
    return
  }
  if (!Pub.REG_IS_INTEGER_OR_FLOAT(camount.value)) {
    message.error('金额必须为正数，且最多2位小数')
    return
  }
  cisLoading.value = true
  const params = {
    user_id: cuid.value,
    amount: camount.value * 1000 / 10
  }
  callbackVirtualDetail(params).then(res => {
    const { code, data } = res
    if (code === 0) {
      Modal.confirm({
        visible: false,
        title: '确认回传数据',
        icon: null,
        content: [
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, 'UID：'), createVNode('span', { style: 'font-weight: 700;' }, data.user_id)]),
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, '推广ID：'), createVNode('span', { style: 'font-weight: 700;' }, data.adv_id)]),
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, '链接名称：'), createVNode('span', { style: 'font-weight: 700;' }, data.drama_popularize_name)]),
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, '回传金额：'), createVNode('span', { style: 'font-weight: 700;' }, `${Pub.KEEP_NUMBER_DECIMAL((data.amount || 0) / 100, 2, false, true)}元`)]),
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, '推广渠道：'), createVNode('span', { style: 'font-weight: 700;' }, (ChannelTypes.find(item => item.value === data.channel) || {}).text || '-')]),
          createVNode('div', { style: 'color: #5A5A5A;' }, [createVNode('span', {}, '计划ID：'), createVNode('span', { style: 'font-weight: 700;' }, data.adid)]),
          createVNode('div', { style: 'color:red; padding-top: 10px;',}, '注意：一旦创建虚拟回传，该用户在该推广链接下后续的付费数据将不再自动回传。')
        ],
        onOk () {
          virtualCallback(data).then(res => {
            cisLoading.value = false
            const { code } = res
            if (code === 0) {
              message.success('创建成功')
              getList()
            } else {
              Modal.error({
                title: '创建失败',
                content: res.message
              })
            }
          }).catch(() => {
            cisLoading.value = false
          })
        },
        onCancel () {
          cisLoading.value = false
        }
      })
    } else {
      cisLoading.value = false
      Modal.error({
        title: '创建失败',
        content: res.message
      })
    }
  }).catch(() => {
    cisLoading.value = false
    message.error('读取失败')
  })
}

// 获取注册用户列表
function getList () {
  isLoading.value = true
  const params = {
    start_time: dateRange.value ? `${dateRange.value[0].format(dateFormat)}` : undefined,
    end_time: dateRange.value ? `${dateRange.value[1].format(dateFormat)}` : undefined,
    adv_id: promotionID.value,
    user_id: uid.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  callbackVirtualList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 查询
function handleSearch () {
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function handleReset () {
  // 筛选项重置
  dateRange.value = [dayjs().subtract(30, 'day'), dayjs()]
  uid.value = undefined
  promotionID.value = undefined
  // 分页重置
  pagination.current = 1
  getList()
}
</script>

<style scoped>
.head-tool-view {
  padding-top: 30px;
}
.head-tool-space {
  margin-top: 30px;
  height: 30px;
  background-color: #F0F2F5;
  margin-left: -24px;
  margin-right: -24px;
}
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>